// Hands a question from the public homepage to the chat page without putting it in the URL,
// so question text never reaches analytics, server logs, or Referer headers. sessionStorage
// is per tab and survives the login/signup redirect in that tab.

const PENDING_QUESTION_KEY = "hoalaw_pending_question_v1";
const MAX_LENGTH = 500;

/** Stores the question; returns false when storage is unavailable (caller falls back to ?q=). */
export function savePendingQuestion(question: string): boolean {
  try {
    window.sessionStorage.setItem(PENDING_QUESTION_KEY, question.slice(0, MAX_LENGTH));
    return true;
  } catch {
    return false;
  }
}

/** Returns and clears the stored question, if any. */
export function takePendingQuestion(): string | null {
  try {
    const value = window.sessionStorage.getItem(PENDING_QUESTION_KEY);
    if (value !== null) window.sessionStorage.removeItem(PENDING_QUESTION_KEY);
    return value;
  } catch {
    return null;
  }
}
